// @ts-nocheck
import { AbstractServiceRequestOpMessage } from "./AbstractServiceRequestOpMessage";

export class ServiceRequestOpMessage extends AbstractServiceRequestOpMessage {
  constructor() {
    super();
  }
}
